var EtdV1ManagementRecommendationsExporter, EtdV2ManagementRecommendationsExporter, ManagementRecommendationsExporter;

EtdV1ManagementRecommendationsExporter = require('./etdv1_management_recommendations_exporter');

EtdV2ManagementRecommendationsExporter = require('./etdv2_management_recommendations_exporter');

module.exports = ManagementRecommendationsExporter = (function() {
  function ManagementRecommendationsExporter(_originalQuestion, etdVersion) {
    switch (etdVersion) {
      case "v1":
        _(this).extend(new EtdV1ManagementRecommendationsExporter(_originalQuestion));
        break;
      case "v2":
        _(this).extend(new EtdV2ManagementRecommendationsExporter(_originalQuestion));
        break;
      default:
        throw new Error("Unknown ETD version");
    }
  }

  return ManagementRecommendationsExporter;

})();
